import { render, staticRenderFns } from "./ModalVotingResults.vue?vue&type=template&id=2fc58ded"
import script from "./ModalVotingResults.vue?vue&type=script&lang=js"
export * from "./ModalVotingResults.vue?vue&type=script&lang=js"
import style0 from "./ModalVotingResults.vue?vue&type=style&index=0&id=2fc58ded&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports